/**
 * Brand color constants used across the design system docs.
 * These values are shared between CSS variables and JavaScript color calculations.
 */
export const BRAND_COLORS = {
	blue: '#1868DB',
	purple: '#BF63F3',
	orange: '#FCA700',
	lime: '#94C748',
	black: '#101214',
} as const;

/**
 * Array of brand colors in order for scroll dots and other sequential color usage.
 */
export const BRAND_COLORS_ARRAY: readonly ['#1868DB', '#94C748', '#BF63F3', '#FCA700'] = [
	BRAND_COLORS.blue,
	BRAND_COLORS.lime,
	BRAND_COLORS.purple,
	BRAND_COLORS.orange,
] as const;
